import { Button, Divider, FormControl, Grid, IconButton, InputLabel, Menu, MenuItem, Paper, Select, Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import AppSearchBar from "../../../Components/AppSearchBar";
import { useStyles } from './style';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import FilesContainer from "./FilesContainer";
import FolderContainer from "./FolderContainer";
import DetailFolderview from "./DetailFolderView";
import Modal from '@mui/material/Modal';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { getallresource } from "../../../Utils/apiService";
import FilterIcon from '../../../Assets/filter.svg';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; // for file icons
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart';
import useSpeechRecognition from '../../../hooks/useSpeechRecognition';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const Resources = () => {
  const [value, setValue] = React.useState(0);
  const [localSearchInput, setLocalSearchInput] = useState('');
  const [searchInput, setSearchInput] = useState<string>('');
  const classes = useStyles();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [isDetailViewOpen, setIsDetailViewOpen] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [selectedCollaborators, setSelectedCollaborators] = useState<any[]>([]);
  const collaboratorsList = [
    { label: 'John Doe', id: 1 },
    { label: 'Jane Smith', id: 2 },
    { label: 'Alice Johnson', id: 3 },
    { label: 'Bob Brown', id: 4 },
  ];
  const [apiFolders, setApiFolders] = useState<any[]>([]);
  const [allFiles, setAllFiles] = useState<any[]>([]);

  const [filesSearch, setFilesSearch] = useState<string>("");
  const [filesSort, setFilesSort] = useState<string>("");
  const [foldersSearch, setFoldersSearch] = useState<string>("");
  const [foldersSort, setFoldersSort] = useState<string>("");

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [Sortby, setSortby] = useState('');
  const { startListening, stopListening, isSupported } = useSpeechRecognition({
    onResult: (speechResult: string) => {
      setLocalSearchInput(speechResult);
      setSearchInput(speechResult);
    },
    onStart: () => setNotificationOpen(true),
    onEnd: () => setNotificationOpen(false),
    onError: (event: Event) => {
      console.error('Speech recognition error:', event);
      setNotificationOpen(false);
    },
  });
  const handleMicHold = () => {
    if (!isSupported) {
      console.log('Speech recognition not supported');
      return;
    }
    startListening();
  };
  const handleMicRelease = () => {
    stopListening();
  };
  const handleChanges = (event: any) => {
    const sortOption = event.target.value;
    setSortby(sortOption);
  };

  // Handler to open detail view for a folder
  const handleFolderClick = (folderId: string) => {
    setSelectedFolderId(folderId);
    setIsDetailViewOpen(true);
  };

  // Handler to go back from detail view
  const handleBackFromDetail = () => {
    setIsDetailViewOpen(false);
    setSelectedFolderId(null);
  };

  // Find the selected folder's detail data
  useEffect(() => {
    getallresource().then((res) => {
      console.log(res, "res12321232123");
    })
  }, [])

  // Helper: format date to "30 May, 2025"
  const formatDate = (iso: string) => {
    if (!iso) return '';
    const date = new Date(iso);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, ' ');
  };

  // Helper: get preview image/icon for file type
  const getFilePreview = (file: any) => {
    if (file.fileType?.toLowerCase().includes('png') || file.fileType?.toLowerCase().includes('jpg') || file.fileType?.toLowerCase().includes('jpeg')) {
      return file.publicUrl || null;
    }
    if (file.fileType?.toLowerCase() === 'pdf') return 'pdf';
    if (file.fileType?.toLowerCase() === 'csv') return 'csv';
    if (file.fileType?.toLowerCase().includes('doc')) return 'doc';
    return 'file';
  };

  // Fetch and transform API data
  useEffect(() => {
    getallresource().then((res) => {
      const folders = res?.data?.data || [];
      setApiFolders(folders);

      // Flatten all files from all folders
      const files = folders.flatMap((folder: any) =>
        (folder.files || []).map((file: any) => ({
          id: file.id,
          title: file.title,
          imageUrl: getFilePreview(file),
          fileType: file.fileType,
          publicUrl: file.publicUrl,
          size: file.size,
          Lastupdated: formatDate(file.createdDate),
          createdDate: file.createdDate,
          folderId: folder.id,
          folderName: folder.name,
        }))
      );
      setAllFiles(files);
    });
  }, []);

  // Folders cardData
  const foldersCardData = apiFolders.map(folder => {
    // Find latest file date
    let latestDate = '';
    if (folder.files?.length) {
      latestDate = folder.files.reduce((latest: string, file: any) =>
        (!latest || new Date(file.createdDate) > new Date(latest)) ? file.createdDate : latest
        , '');
    }
    return {
      id: folder.id,
      title: folder.name,
      Lastupdated: formatDate(latestDate),
      latestDate: latestDate,
      collaborators: folder.files?.length || 0,
      avatarUrl: folder.adminProfilePicUrl || '',
      userName: folder.adminName || '',
    };
  });

  // Find the selected folder's detail data
  const selectedFolder = apiFolders.find(f => f.id === selectedFolderId);
  const selectedFolderFiles = (selectedFolder?.files || []).map((file: any) => ({
    id: file.id,
    title: file.title,
    imageUrl: getFilePreview(file),
    fileType: file.fileType,
    publicUrl: file.publicUrl,
    size: file.size,
    Lastupdated: formatDate(file.createdDate),
    createdDate: file.createdDate,
    folderId: selectedFolder?.id,
    folderName: selectedFolder?.name,
  }));

  const filteredFiles = allFiles
    .filter(file => file.title.toLowerCase().includes(filesSearch.toLowerCase()));
  if (filesSort === "Newest First") {
    filteredFiles.sort((a, b) => new Date(b.createdDate || 0).getTime() - new Date(a.createdDate || 0).getTime());
  } else if (filesSort === "Oldest First") {
    filteredFiles.sort((a, b) => new Date(a.createdDate || 0).getTime() - new Date(b.createdDate || 0).getTime());
  }

  const filteredFolders = foldersCardData
    .filter(folder => folder.title.toLowerCase().includes(foldersSearch.toLowerCase()));
  if (foldersSort === "Newest First") {
    filteredFolders.sort((a, b) => new Date(b.latestDate || 0).getTime() - new Date(a.latestDate || 0).getTime());
  } else if (foldersSort === "Oldest First") {
    filteredFolders.sort((a, b) => new Date(a.latestDate || 0).getTime() - new Date(b.latestDate || 0).getTime());
  }

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const sortOptions = ['Newest First', 'Oldest First'];

  const handleSortButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSortSelect = (option: string) => {
    if (value === 0) {
      setFilesSort(option);
    } else {
      setFoldersSort(option);
    }
    setAnchorEl(null);
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <Box
      sx={{
        height: { md : "calc(100vh - 143px)" , sm : "100%"},
        textAlign: "left",
        display: 'flex',
        flexDirection: 'column',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
          height: '85vh',
        },
        overflow: 'hidden',
      }}
      className="scrollbar-cusgrayHeader"
    >
      <Grid>
        <Grid container style={{ textAlign: "left" }}>
          <Grid
            item
            md={12}
            lg={12}
            xl={12}
            xs={12}
            sx={{
              backgroundColor: 'white',
              marginTop: { xs: '0px', sm: '15px' },
              padding: { xs: '10px 10px 0px 10px', sm: '15px 15px 0px 15px' },
              borderRadius: '8px',
            }}
          >
            <Box
              sx={{
                position: { xs: 'sticky', sm: 'sticky', md: 'static' },
                top: { xs: 0, sm: 0, md: 'unset' },
                zIndex: { xs: 10, sm: 10, md: 'auto' },
                background: { xs: 'white', sm: 'white', md: 'unset' },
                borderRadius: { xs: '0 0 8px 8px', md: '8px' },
              }}
            >
              <Tabs TabIndicatorProps={{
                style: {
                  backgroundColor: '#FAB400'
                },
              }}
                value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab
                  label="Files"
                  {...a11yProps(0)}
                  sx={{
                    textTransform: 'none',
                    fontSize: 16,
                    '&.Mui-selected': {
                      color: '#373A45',
                    }
                  }}
                />
                <Tab
                  label="Folders"
                  {...a11yProps(1)}
                  sx={{
                    textTransform: 'none',
                    fontSize: 16,
                    '&.Mui-selected': {
                      color: '#373A45',
                    }
                  }}
                />
              </Tabs>
            </Box>
          </Grid>
        </Grid>
        {!isDetailViewOpen ? (
          <Grid>
            <CustomTabPanel value={value} index={0}>
              <Grid className="scrollbar-cusgray" container sx={{
                height: { md: "calc(100vh - 235px)" , sm : "calc(100vh - 100px)"},
                overflowY: 'auto'
              }}>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  xl={12}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    padding: { xs: 1.5, sm: 2 },
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid
                    container
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    className={classes.stickyControls}
                    columnSpacing={{ sm: 0 }} // Small gap between search and sort in mobile
                    sx={{ marginBottom: { xs: '6px', sm: '10px' } }}
                  >
                    <Grid item >
                      <Typography
                        sx={{
                          fontSize: '16px',
                          color: '#373A45',
                          marginBottom: { xs: '6px', sm: '10px' },
                          fontWeight: '500',
                          textAlign: 'start',
                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                            fontSize: '12px !important',
                          },
                          '@media (min-width: 1920px) and (max-width: 1940px)': {
                            fontSize: '20px !important',
                          },
                        }}
                      >
                        {'All Files'}
                      </Typography>
                    </Grid>

                    {/* AppSearchBar: 8 columns on mobile */}
                    <Grid
                      item

                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                        gap: { xs: 1.5, sm: 3 },
                        flexWrap: { xs: 'nowrap', sm: 'nowrap' },
                        width: { xs: '100%', sm: 'auto' },
                      }}
                      className={classes.mobileContainer}
                    >
                      <Box sx={{ width: { xs: '65%', sm: 'auto' }, flex: { xs: '1 1 65%', sm: '0 0 auto' } }}>
                        <AppSearchBar
                          handleMicHold={handleMicHold}
                          handleMicRelease={handleMicRelease}
                          localSearchInput={filesSearch}
                          openSnackbar={notificationOpen}
                          handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilesSearch(e.target.value)}
                        />
                      </Box>
                      <FormControl
                        sx={{
                          width: { xs: '35%', sm: '50%' },
                          // paddingRight: { xs: '0', sm: '0', md: '3%' },
                          fontSize: '12px'
                        }}
                        size="small"
                      >
                        <Button
                          size="medium"
                          variant="contained"
                          color="info"
                          endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                          sx={{
                            width: { xs: '100%', sm: 'fitContent' }
                          }}
                          onClick={handleSortButtonClick}
                          fullWidth
                          type="button"
                        >
                          <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                            {filesSort ? filesSort : 'Sort by'}
                          </Typography>
                        </Button>

                        <Menu
                          anchorEl={anchorEl}
                          open={isMenuOpen}
                          onClose={handleMenuClose}
                          PaperProps={{
                            sx: {
                              borderRadius: 2,
                              minWidth: 180,
                              boxShadow: 3,
                              mt: 1,
                              backgroundColor: '#FFFFFF',
                            },
                          }}
                        >
                        <MenuItem
                          onClick={() => handleSortSelect('')}
                          selected={foldersSort === ''}
                          sx={{ fontWeight: foldersSort === '' ? 600 : 400 }}
                        >
                          Clear
                        </MenuItem>

                          {sortOptions.map((option) => (
                            <MenuItem
                              key={option}
                              onClick={() => handleSortSelect(option)}
                              selected={foldersSort === option}
                              sx={{ fontWeight: foldersSort === option ? 600 : 400 }}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Menu>
                      </FormControl>
                    </Grid>

                    {/* Sort dropdown: 4 columns on mobile */}

                  </Grid>
                  <Box
                    className={`scrollbar-cusgray ${classes.cardContainer}`}
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden'
                    }}
                  >
                    <FilesContainer cardData={filteredFiles} />
                  </Box>
                </Grid>

              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Grid container sx={{
                height: { md : 'calc(100vh - 235px)' , sm : 'calc(100vh - 100px)'},
                overflowY: 'auto'
              }}>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  xl={12}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    padding: { xs: 1.5, sm: 2 },
                    height: { xs: 'auto', sm: 'auto', md: '100%' },
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid
                    container
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    className={classes.stickyControls}
                    columnSpacing={{ xs: 1, sm: 0 }}
                    sx={{ marginBottom: { xs: '6px', sm: '10px' } }}
                  >
                    <Grid >
                      <Typography
                        sx={{
                          fontSize: '16px',
                          color: '#373A45',
                          fontWeight: '500',
                          marginBottom: { xs: '6px', sm: '10px' },
                          textAlign: 'start',
                          '@media (min-width: 1280px) and (max-width: 1300px)': {
                            fontSize: '12px !important',
                          },
                          '@media (min-width: 1920px) and (max-width: 1940px)': {
                            fontSize: '20px !important',
                          },
                        }}
                      >
                        {'All Folders'}
                      </Typography>
                    </Grid>


                    <Grid
                      item

                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                        gap: { xs: 1.5, sm: 3 },
                        flexWrap: { xs: 'nowrap', sm: 'nowrap' },
                        width: { xs: '100%', sm: 'auto' },
                      }}
                      className={classes.mobileContainer}
                    >
                      <Box sx={{ width: { xs: '65%', sm: 'auto' }, flex: { xs: '1 1 65%', sm: '0 0 auto' } }}>
                        <AppSearchBar
                          handleMicHold={handleMicHold}
                          handleMicRelease={handleMicRelease}
                          localSearchInput={foldersSearch}
                          openSnackbar={notificationOpen}
                          handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setFoldersSearch(e.target.value)}
                        />
                      </Box>
                      <FormControl
                        sx={{
                          width: { xs: '35%', sm: '50%' },
                          // paddingRight: { xs: '0', sm: '0', md: '3%' },
                          fontSize: '12px'
                        }}
                        size="small"
                      >
                        <Button
                          size="medium"
                          variant="contained"
                          color="info"
                          endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                          sx={{
                            width: { xs: '100%', sm: 'fitContent' }
                          }}
                          onClick={handleSortButtonClick}
                          fullWidth
                          type="button"
                        >
                          <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>
                            {foldersSort ? foldersSort : 'Sort by'}
                          </Typography>
                        </Button>

                        <Menu
                          anchorEl={anchorEl}
                          open={isMenuOpen}
                          onClose={handleMenuClose}
                          PaperProps={{
                            sx: {
                              borderRadius: 2,
                              minWidth: 180,
                              boxShadow: 3,
                              mt: 1,
                              backgroundColor: '#FFFFFF',
                            },
                          }}
                        >
                          <MenuItem
                            onClick={() => handleSortSelect('')}
                            selected={filesSort === ''}
                            sx={{ fontWeight: filesSort === '' ? 600 : 400 }}
                          >
                            Clear
                          </MenuItem>

                          {sortOptions.map((option) => (
                            <MenuItem
                              key={option}
                              onClick={() => handleSortSelect(option)}
                              selected={filesSort === option}
                              sx={{ fontWeight: filesSort === option ? 600 : 400 }}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Menu>
                      </FormControl>
                    </Grid>

                    {/* <Grid
                      item
                      xs={8}
                      sm={12}
                      md={3}
                      lg={3}
                      xl={3}
                      sx={{ mb: { xs: 1, sm: 1, md: 0 }, display: 'flex', alignItems: 'center' }}
                      className={classes.mobileContainer}
                    >
                      <AppSearchBar
                        handleMicHold={handleMicHold}
                        handleMicRelease={handleMicRelease}
                        localSearchInput={foldersSearch}
                        openSnackbar={notificationOpen}
                        handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setFoldersSearch(e.target.value)}
                      />
                    </Grid> */}

                    {/* Sort dropdown: 4 columns on mobile */}
                    {/* <Grid
                      item
                      xs={4}
                      sm={12}
                      md={1.5}
                      lg={1.5}
                      xl={1.5}
                      sx={{ mb: { xs: 1, sm: 0 }, display: 'flex', alignItems: 'center' }}
                    >
                      <FormControl
                        sx={{
                          width: '100%',
                          paddingRight: { xs: '0', sm: '0', md: '3%' },
                          fontSize: '12px'
                        }}
                        size="small"
                      >
                        <InputLabel id="folders-sort-label">Sort by</InputLabel>
                        <Select
                          labelId="folders-sort-label"
                          id="folders-sort-select"
                          value={foldersSort}
                          label="Sort by"
                          onChange={(e) => setFoldersSort(e.target.value as string)}
                          sx={{
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            '& .MuiSelect-select': {
                              paddingTop: '0 !important',
                              paddingBottom: '0 !important',
                              display: 'flex',
                              alignItems: 'center',
                              height: '100%',
                            }
                          }}
                        >
                          <MenuItem value="">Clear</MenuItem>
                          <MenuItem value={"A - Z"}>A - Z</MenuItem>
                          <MenuItem value={"Z - A"}>Z - A</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid> */}
                  </Grid>
                  <Grid
                    className={`scrollbar-cusgray ${classes.cardContainer}`}
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden'
                    }}
                  >
                    <FolderContainer cardData={filteredFolders} onFolderClick={handleFolderClick} />
                  </Grid>
                </Grid>
              </Grid>
            </CustomTabPanel>
          </Grid>
        ) : (
          // Detail Folder View
          <Grid>
            <Grid container  sx={{ pt: 2,position:'relative' , height: { md : 'calc(100vh - 216px)' , sm:"calc(100vh - 100px)"},}} >
              <Grid item lg={12} xl={12} style={{ backgroundColor: "white", borderRadius: "8px", padding: 15, width: '100%' }}>
                <Grid style={{ marginBottom: 10 }} container display="flex" alignItems="center" justifyContent="space-between">
                  <Grid item md={12} lg={12} xl={12}>
                    <Typography
                      sx={{
                        fontSize: '15px',
                        color: '#373A45',
                        fontWeight: '500',
                        textAlign: 'start',
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '12px !important',
                        },
                        '@media (min-width: 1920px) and (max-width: 1940px)': {
                          fontSize: '20px !important',
                        },
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <IconButton onClick={handleBackFromDetail} size="small">
                        <ArrowBackTwoToneIcon />
                      </IconButton>
                      {/* Show folder title if available */}
                      {selectedFolder?.name || "Folder"}
                    </Typography>
                  </Grid>
                  <Grid item md={1} lg={1} xl={1}>
                    {/* <Button
                      style={{ color: "white", backgroundColor: "#F7A703", borderRadius: 6, float: "right", fontWeight: "400", width: "95%", fontSize: 12 }}
                    >
                      Add new +
                    </Button> */}
                  </Grid>
                </Grid>
                <Grid
                  className={`scrollbar-cusgray ${classes.cardContainer} `}
                  sx={{
                    overflowY: { xs: 'auto', sm: 'auto', md: 'visible' },
                    maxHeight: { xs: 'calc(100vh - 200px)', sm: 'calc(100vh - 200px)', md: 'none' },
                  }}
                >
                  {selectedFolderFiles.length > 0 ? (
                    <DetailFolderview cardData={selectedFolderFiles} />
                  ) : (
                    <Typography sx={{ textAlign: 'center', mt: 4, color: '#888' }}>
                      No data available for this folder.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      {/* Modal for Create New Folder */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="create-folder-modal-title"
        aria-describedby="create-folder-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            outline: 'none'
          }}
        >
          <Typography id="create-folder-modal-title" sx={{ mb: 1, fontSize: "16px", fontWeight: 500 }}>
            Create a new folder
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography sx={{ fontSize: 14, mb: 1 }}>
            Folder Name <span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            required
            size="small"
            value={folderName}
            onChange={e => setFolderName(e.target.value)}
            placeholder="Enter folder name"
            sx={{ mb: 2 }}
          />
          <Typography sx={{ fontSize: 14, mb: 1 }}>
            Add collaborators
          </Typography>
          <Autocomplete
            multiple
            options={collaboratorsList}
            getOptionLabel={(option) => option.label}
            value={selectedCollaborators}
            onChange={(_, value) => setSelectedCollaborators(value)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Select collaborators" size="small" />
            )}
            sx={{ mb: 2 }}
          />
          {/* You can add a submit button here if needed */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{
                bgcolor: 'white',
                color: '#00387A',
                borderColor: '#00387A',
                '&:hover': {
                  bgcolor: '#f5f5f5',
                  borderColor: '#00387A',
                },
                textTransform: 'none',
                minWidth: 100,
                fontWeight: 500
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                background: 'linear-gradient(90deg, #00387A 0%, #006BB7 100%)',
                color: 'white',
                textTransform: 'none',
                minWidth: 100,
                fontWeight: 500,
                boxShadow: 'none',
                '&:hover': {
                  background: 'linear-gradient(90deg, #00387A 0%, #006BB7 100%)',
                  boxShadow: 'none'
                }
              }}
            // onClick={handleCreateFolder} // Add your create handler here
            >
              Create
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
export default Resources;
